import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import PDFIcon from "assets/icons/pdf.svg?react";
import DocIcon from "assets/icons/doc.svg?react";

const FormatCell: FC<Props> = ({ element }) => {
  const isPdf = element.S1 !== null && element.S1.toLowerCase().endsWith(".pdf");

  return (
    <div className={styles.wrapper}>
      <div className={styles.name}>
        {isPdf && <PDFIcon className={`${styles.icon}`} />}
        {!isPdf && <DocIcon className={`${styles.icon}`} />}
        {element.S2}
      </div>
    </div>
  );
};

export default FormatCell;
